import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  DraftListingSection,
  useDraftListing,
} from '../../contexts/DraftListingContext';
import BrokerageParticipants from '../edit/control/BrokerageParticipants';
import OwnerDetails from '../edit/control/OwnerDetails';
import { CreateGridLayout } from '../../constants/Grid';
import { ErrorBoundary } from '../common/ErrorBoundary';
import FallbackError from '../common/FallbackError';
import FormAccordion from '../common/FormAccordion';

const Participants: React.FC = () => {
  const { show } = useDraftListing();

  if (!show(DraftListingSection.Participants)) {
    return null;
  }

  return (
    <ErrorBoundary fallback={<FallbackError />}>
      <FormAccordion
        title="Transaction Participants"
        subtext={
          'Update or add any additional transaction participants for your client or brokerage.'
        }
        defaultExpanded={false}
      >
        <Box sx={{ mt: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 3,
            }}
          >
            <Typography variant={'h5'}>Brokerage Participants</Typography>
          </Box>
          <BrokerageParticipants
            gridProps={CreateGridLayout}
            hideBuyerAgentFields={true}
          />
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant={'h5'} mb={3}>
            Owner Details
          </Typography>

          <OwnerDetails gridProps={CreateGridLayout} />
        </Box>
      </FormAccordion>
    </ErrorBoundary>
  );
};

export default Participants;
